import { Home, Shield, Umbrella, HeartHandshake } from "lucide-react";

export const HomeCoverage = () => {
  return (
    <section className="py-12 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.2s" }}>
            <h2 className="text-2xl font-semibold text-primary-dark mb-4">
              Property Coverage
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Home className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Dwelling Protection</h3>
                  <p className="text-neutral">Covers your home's structure and attached structures.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Personal Property</h3>
                  <p className="text-neutral">Protection for your belongings and valuables.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Umbrella className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Weather Protection</h3>
                  <p className="text-neutral">Coverage against natural disasters and severe weather.</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.4s" }}>
            <h2 className="text-2xl font-semibold text-primary-dark mb-4">
              Additional Protection
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <HeartHandshake className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Liability Coverage</h3>
                  <p className="text-neutral">Protection if someone is injured on your property.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Home className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Additional Living Expenses</h3>
                  <p className="text-neutral">Coverage for temporary housing if your home is uninhabitable.</p>
                </div>
              </li>
              <li className="flex items-start">
                <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
                <div>
                  <h3 className="font-medium">Extended Coverage</h3>
                  <p className="text-neutral">Optional coverage for valuable items and special circumstances.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};